import React, { PropTypes } from 'react'

import './ReviewCard.scss'
import StarRating from 'components/StarRating'
import { formatLongDate } from 'utils/dates'

const fullName = ({ firstName, lastName }) => {
  return lastName ? `${firstName} ${lastName}` : firstName
}

const ReviewCard = (props) => {
  const {
    rating
  } = props

  const date = formatLongDate(rating.createdAt)

  return (
    <div className='ReviewCard'>
      <div className='ReviewCard-value'>
        <StarRating value={rating.value} min={0} max={5} />
      </div>
      <div className='ReviewCard-comment'>"{rating.comment}"</div>
      <div className='ReviewCard-reviewer'>{fullName(rating.user)} • {date}</div>
    </div>
  )
}
ReviewCard.displayName = 'ReviewCard'
ReviewCard.propTypes = {
  rating: PropTypes.shape({
    comment: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired,
    user: PropTypes.shape({
      firstName: PropTypes.string.isRequired,
      lastName: PropTypes.string
    }).isRequired,
    createdAt: PropTypes.string.isRequired
  }).isRequired
}

export default ReviewCard



// WEBPACK FOOTER //
// ./src/screens/App/shared/components/ReviewCard/ReviewCard.js